import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/azienda", label: "Chi siamo" },
  { to: "/parco-veicoli", label: "Parco Veicoli" },
  { to: "/noleggio", label: "Noleggio" },
  { to: "/vendi-auto", label: "Vendi la tua Auto" },
  { to: "/contatti", label: "Contatti" },
];

export const LOGO_URL = "https://customer-assets-0z36b82j.emergentagent.net/job_cmc-auto-altamura/artifacts/b8y38fm5_Gemini_Generated_Image_9jbrw79jbrw79jbr.jpg";
export const LOGO_ROUND = "https://customer-assets-0z36b82j.emergentagent.net/job_cmc-auto-altamura/artifacts/ddg3frvm_Gemini_Generated_Image_kobqm0kobqm0kobq.jpg";

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#0B0B0C]/90 border-b border-white/10" data-testid="header">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="header-logo">
          <img src={LOGO_URL} alt="LC AUTO" className="h-10 md:h-12 object-contain" style={{ mixBlendMode: "screen", background: "transparent" }} />
        </Link>
        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                `font-display text-xs tracking-widest transition ${isActive ? "text-[#E1BC56]" : "text-white/80 hover:text-[#F3E29F]"}`
              }
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/admin" className="cmc-btn-outline text-xs px-4 py-2 rounded-sm" data-testid="nav-admin">
            Area Admin
          </Link>
        </nav>
        <button onClick={() => setOpen(!open)} className="lg:hidden text-[#E1BC56]" data-testid="mobile-menu-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-white/10 bg-[#0B0B0C]" data-testid="mobile-menu">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.to === "/"} onClick={() => setOpen(false)}
              className={({ isActive }) => `block px-6 py-3 font-display text-sm tracking-widest border-b border-white/5 ${isActive ? "text-[#E1BC56]" : "text-white/80"}`}>
              {l.label}
            </NavLink>
          ))}
          <Link to="/admin" onClick={() => setOpen(false)} className="block px-6 py-3 font-display text-sm tracking-widest text-[#E1BC56]">Area Admin</Link>
        </div>
      )}
    </header>
  );
};
